<template>
  <b-container fluid>
    <b-row>
      <b-col cols="12">
        <PageHeader
          :page="header"
          left-side-class="col-12 col-lg-8"
          right-side-class="col-12 col-lg-4 d-flex align-items-center justify-content-end"
        >
          <template #customActions>
            <portal-target :name="layoutHeaderActions" />
          </template>
        </PageHeader>
      </b-col>
      <b-col cols="12">
        <RouterView />
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import PageHeader from 'PageHeader';

import { unRegisterMixin } from '@/mixin/storeGenerator';

export default {
  name: 'LocationAlternativesDefaultLayout',
  mixins: [unRegisterMixin],
  components: { PageHeader },
  provide() {
    return { layoutHeaderActions: this.layoutHeaderActions };
  },
  data: () => ({
    header: {
      icon: 'fas fa-user-tie',
      title: 'Catálogo de Alternativa de Ubicación',
      routes: ['Inicio', 'PEI', 'Catálogo de Alternativa de Ubicación'],
    },
    layoutHeaderActions: 'location-alternatives_layout_default_header_actions',
  }),
};
</script>
